import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const popups = [{
  initials: 'MG',
  avatarBg: '#1B3A6B',
  name: 'Marcela G. — Buenos Aires',
  action: 'acaba de descargar el pack completo 🚨',
  time: 'hace 3 minutos'
}, {
  initials: 'RP',
  avatarBg: '#7C3AED',
  name: 'Roberto P. — Córdoba',
  action: 'compró el sistema para su escuela ✅',
  time: 'hace 7 minutos'
}, {
  initials: 'VS',
  avatarBg: '#2D9B6F',
  name: 'Valeria S. — Rosario',
  action: 'descargó Código Emergencia Escolar 📚',
  time: 'hace 12 minutos'
}, {
  initials: 'DM',
  avatarBg: '#FF6B35',
  name: 'Daniela M. — Mendoza',
  action: 'acaba de acceder al pack completo 🎉',
  time: 'hace 5 minutos'
}, {
  initials: 'CL',
  avatarBg: '#E63946',
  name: 'Claudia L. — La Plata',
  action: 'compró el sistema para nivel primario ✅',
  time: 'hace 9 minutos'
}, {
  initials: 'JM',
  avatarBg: '#1B3A6B',
  name: 'Jorge M. — Buenos Aires',
  action: 'descargó el pack completo ahora 🚨',
  time: 'hace 2 minutos'
}, {
  initials: 'AS',
  avatarBg: '#00BFA5',
  name: 'Andrea S. — Mendoza',
  action: 'acaba de unirse con su escuela 📋',
  time: 'hace 15 minutos'
}, {
  initials: 'LB',
  avatarBg: '#4A90D9',
  name: 'Laura B. — Córdoba',
  action: 'descargó Código Emergencia Escolar ✅',
  time: 'hace 6 minutos'
}, {
  initials: 'NP',
  avatarBg: '#7C3AED',
  name: 'Natalia P. — Santa Fe',
  action: 'compró el pack para su grado 🎉',
  time: 'hace 11 minutos'
}, {
  initials: 'PT',
  avatarBg: '#FF6B35',
  name: 'Paula T. — Tucumán',
  action: 'acaba de descargar el sistema 🚨',
  time: 'hace 4 minutos'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [pastHero, setPastHero] = useState(false);
  const timersRef = useRef<{
    show?: number;
    hide?: number;
  }>({});
  // Track scroll to determine if user is past hero (>100vh)
  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY > window.innerHeight;
      setPastHero(scrolled);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Cycle popups while past hero
  useEffect(() => {
    if (!pastHero) {
      setVisible(false);
      if (timersRef.current.show) window.clearTimeout(timersRef.current.show);
      if (timersRef.current.hide) window.clearTimeout(timersRef.current.hide);
      return;
    }
    let cancelled = false;
    const showOnce = (delay: number) => {
      timersRef.current.show = window.setTimeout(() => {
        if (cancelled) return;
        setVisible(true);
        timersRef.current.hide = window.setTimeout(() => {
          if (cancelled) return;
          setVisible(false);
          setCurrentIndex(prev => (prev + 1) % popups.length);
          // Next popup after 14s gap
          showOnce(14000);
        }, 4000);
      }, delay);
    };
    // First popup 3s after entering past-hero state
    showOnce(3000);
    return () => {
      cancelled = true;
      if (timersRef.current.show) window.clearTimeout(timersRef.current.show);
      if (timersRef.current.hide) window.clearTimeout(timersRef.current.hide);
    };
  }, [pastHero]);
  const current = popups[currentIndex];
  return <AnimatePresence data-id="element-42">
      {visible && pastHero && <motion.div role="alert" aria-live="polite" aria-label="Notificación de compra reciente" initial={{
      opacity: 0,
      x: -40
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -20
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed z-[9999] bg-white rounded-[12px] shadow-[0_4px_20px_rgba(0,0,0,0.15)] flex items-center gap-3 border-l-[4px] border-[#FF6B35] px-4 py-3" style={{
      top: 'max(16px, env(safe-area-inset-top))',
      left: '8px',
      right: '8px',
      maxWidth: 'min(320px, calc(100% - 16px))'
    }} data-id="element-43">
          <div className="w-11 h-11 rounded-full flex items-center justify-center text-white font-poppins font-bold text-[14px] shrink-0" style={{
        backgroundColor: current.avatarBg
      }} aria-hidden="true" data-id="element-44">
            {current.initials}
          </div>
          <div className="flex flex-col min-w-0" data-id="element-45">
            <p className="font-poppins font-bold text-[13px] text-[#2C2C2C] leading-tight truncate" data-id="element-46">
              {current.name}
            </p>
            <p className="text-[12px] text-[#555555] leading-snug mt-0.5" data-id="element-47">
              {current.action}
            </p>
            <p className="text-[11px] text-[#999999] mt-1" data-id="element-48">{current.time}</p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}